import { useEffect, useRef, useState, useMemo } from "react";
import DefaultVivekVani from "../Images/defaultBook.png";
import VivekVanisService from "../Services/Vivekvani";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Styles/BookDetail.css";
import Slider from "react-slick";
import i18n from "../i18n";
import Favfill from "../assets/img/favadd.svg";
import Favempty from "../assets/img/fav.svg";
import { BookContentType } from "./Epub";
import { useTranslation } from "react-i18next";
import { userId } from "../Contexts/LocaleContext";
import "react-toastify/dist/ReactToastify.css";
import { LogInModel } from "./LoginModel";
import leftArrow from "../assets/img/leftArrow1.png";
import rightArrow from "../assets/img/rightArrow1.png";
import EpubServices from "../Services/Epub";
import closeicon from "../Images/close-round-border.svg";
import vivekvanimarkIcon from "../Images/Bookmark.svg"
import Loader from "./Loader";
import VivekVaniCoverPopup from "../Components/BookCoverPopup";
import { listToTree } from "../utils/tocUtils";

const VivekVaniDetailPage = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [vivekvaniDetail, setVivekVaniDetail] = useState<any>(undefined);
  const [refresh, setRefresh] = useState(false);
  const [relateds, setRelatedVivekVanis] = useState<any[] | undefined>(undefined);

  // it useridentity is change in token etc.. than this effect on favourite
  const UserIdentity = localStorage.getItem("UserId") as any;
  console.log("VivekVaniDetailPage Render - UserIdentity:", UserIdentity);

  const location = useLocation();
  const state = location.state as {
    vivekvaniSlug: string;
    vivekvaniId: string;
    vivekvaniName: string;
    authorId: string;
    authorName: string;
    authorSlug: string;
    special: string;
    langId: string;
    catId: string;
    catName: string;
    catSlug: string;
    index: number;
    searched: string;
    pathname: string;
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: <img src={leftArrow} alt="" height="40px" />,
    nextArrow: <img src={rightArrow} alt="" height="40px" />,
  };

  const [logIn, setLogIn] = useState<boolean>(false);

  const closeModal = () => {
    setLogIn(false);
  };

  const [isLiked, setIsLiked] = useState<boolean>(false);
  const [toggleFav, setToggleFav] = useState<boolean>(false);
  const [lang, showLang] = useState("");
  const [vivekvaniMark, setVivekVaniMark] = useState<boolean>(false);
  const [vivekvaniMarkData, setVivekVaniMarkData] = useState<any[] | undefined | any>(
    undefined
  );
  const [vivekvaniId, setVivekVaniId] = useState<string>("")

  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<'description' | 'toc'>('description');
  const [expandedNodes, setExpandedNodes] = useState<Set<string>>(new Set());
  const [lastPos, setLastPos] = useState<any>(null);
  const [lastFontSize, setLastFontSize] = useState<number>(100);
  const [toc, setToc] = useState<any[]>([]);
  const [progress, setProgress] = useState<number>(0);
  const [showCoverPopup, setShowCoverPopup] = useState(false);

  // Optimization: Memoize tree and flattened TOC to avoid expensive re-calculation
  const navigationTree = useMemo(() => listToTree(toc), [toc]);
  const flatToc = useMemo(() => toc, [toc]); // Keep original order for progress calculation

  const notificationRef = useRef<any>(null);

  const showNotification = (message: any) => {
    notificationRef.current.innerText = message;
    notificationRef.current.style.display = "block";

    setTimeout(() => {
      notificationRef.current.style.display = "none";
    }, 3000); // Hide the notification after 2 seconds
  };

  const notify = () => {
    if (UserIdentity) {
      showNotification(
        !isLiked
          ? localStorage.getItem("lan") === "hindi"
            ? "पुस्तक को सफलतापूर्वक मेरी पसंद में जोड़ा गया है।"
            : "VivekVani has been successfully added to the favourites"
          : localStorage.getItem("lan") === "hindi"
            ? "पुस्तक मेरी पसंद से हटा दी गई है।"
            : "VivekVani has been removed from favourites"
      );
    }
  };

  const toggleLike = () => {
    !isLiked
      ? VivekVanisService.addFavourite(vivekvaniId).then((res) => {
        res.status && setIsLiked(true);
      })
      : VivekVanisService.removeFavourite(vivekvaniId).then((res) => {
        res.status && setIsLiked(false);
      });
    setToggleFav((x) => !x);
  };

  const [loginState, setLoginState] = useState<boolean>(false);

  const handleLoginStateChange = (newState: any) => {
    setLoginState(newState === true);
    navigate(`/reader/vivekvanis/` + state?.vivekvaniSlug, {
      state: {
        vivekvaniDetailId: vivekvaniId,
        vivekvaniName: state?.vivekvaniName,
        slug: state?.vivekvaniSlug,
        label: vivekvaniId,
        type: BookContentType.vivek,
      },
    });
  };

  const [description, setDescription] = useState({
    __html: "",
  });

  const toggleNode = (nodeId: string) => {
    setExpandedNodes((prev) => {
      const next = new Set(prev);
      if (next.has(nodeId)) {
        next.delete(nodeId);
      } else {
        next.add(nodeId);
      }
      return next;
    });
  };

  const renderTocNode = (node: any, index: number, flatIndex?: number) => {
    const isExpanded = expandedNodes.has(node.navId || `node-${index}`);
    const hasChildren = node.children && node.children.length > 0;

    // Determine if read/unread based on progress
    const totalChapters = flatToc.length;
    const readCount = Math.floor(totalChapters * progress / 100);

    // If flatIndex is provided, use it. Otherwise, find it in the flat list.
    const currentFlatIndex = flatIndex !== undefined ? flatIndex : flatToc.findIndex(n => n.navId === node.navId);
    const isRead = currentFlatIndex !== -1 && currentFlatIndex < readCount;

    return (
      <li key={node.navId || index} className="toc-node">
        <div
          className={`node ${isRead ? 'read' : 'unread'}`}
          onClick={() => hasChildren && toggleNode(node.navId || `node-${index}`)}
          style={{ cursor: hasChildren ? 'pointer' : 'default' }}
        >
          {hasChildren ? (
            <span className="node-toggle">
              {isExpanded ? '-' : '+'}
            </span>
          ) : (
            <span className="node-bullet">•</span>
          )}
          <div
            className="node-label"
            onClick={(e) => {
              if (!hasChildren) {
                e.stopPropagation();
                console.log("Navigating to TOC Node - VivekVani:", vivekvaniDetail?.slug, "With Data:", "vivekvaniDetailId ", vivekvaniDetail?.id,
                  "vivekvaniName:", vivekvaniDetail?.name,
                  "slug:", vivekvaniDetail?.slug,
                  "location:", node.srcFile + (node.srcAnchor ? `#${node.srcAnchor}` : "") || node.href,
                  "type: ", BookContentType.vivek);

                navigate(`/reader/vivekvanis/` + vivekvaniDetail?.slug, {
                  state: {
                    vivekvaniDetailId: vivekvaniDetail?.id,
                    vivekvaniName: vivekvaniDetail?.name,
                    slug: vivekvaniDetail?.slug,
                    location: node.srcFile + (node.srcAnchor ? `#${node.srcAnchor}` : "") || node.href,
                    tocNode: node,
                    type: BookContentType.vivek,
                  },
                });
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            {node.label || node.title}
          </div>
        </div>
        {hasChildren && (
          <ul className={`children ${isExpanded ? 'expanded' : ''}`}>
            {node.children.map((child: any, cIdx: number) => {
              // Pass the child's global index for correct progress styling
              // Efficiency: we could optimize this further with a Map, but for normal TOCs this is fast enough
              const childFlatIndex = flatToc.findIndex(n => n.navId === child.navId);
              return renderTocNode(child, `${index}-${cIdx}` as any, childFlatIndex);
            })}
          </ul>
        )}
      </li>
    );
  };

  function createMarkup() {
    return { __html: description.__html };
  }

  const hasVisibleDescription = useMemo(() => {
    const html = description?.__html || "";
    const text = html
      .replace(/&nbsp;/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();
    return text.length > 0;
  }, [description]);

  const hasToc = toc.length > 0;

  useEffect(() => {
    if (!hasVisibleDescription && activeTab === "description") {
      if (hasToc) setActiveTab("toc");
    }
  }, [hasVisibleDescription, activeTab, hasToc]);

  useEffect(() => {
    if (!hasToc && activeTab === "toc") {
      if (hasVisibleDescription) setActiveTab("description");
    }
  }, [hasToc, activeTab, hasVisibleDescription]);

  const indicatorTranslate = useMemo(() => {
    if (!hasVisibleDescription && !hasToc) return "0";
    if (!hasVisibleDescription) return "0";
    if (!hasToc) return "0";
    return activeTab === "description" ? "0" : "172px";
  }, [hasVisibleDescription, hasToc, activeTab]);

  useEffect(() => {
    if (location.state) {
      setVivekVaniId(state?.vivekvaniId);
    }
  }, [location])

  useEffect(() => {
    const fetchData = async () => {
      if (vivekvaniId) {
        try {
          setLoading(true);
          const isGuest = !UserIdentity || UserIdentity === "null" || UserIdentity === "";

          const [vivekvaniRes, navRes] = await Promise.all([
            VivekVanisService.getVivekVaniDetail(vivekvaniId, isGuest ? "" : UserIdentity),
            VivekVanisService.getNavigationDetails(vivekvaniId) // Attempt for everyone
          ]);
          console.log("API Responses - VivekVani:", vivekvaniRes, "Nav:", navRes);

          if (vivekvaniRes?.status) {
            setDescription({ __html: vivekvaniRes.result?.description });
            setVivekVaniDetail(vivekvaniRes.result);
            setIsLiked(vivekvaniRes.result?.isFavourite);
          }

          if (navRes?.status) {
            setToc(navRes.result?.navigationTree || []);
            if (navRes.result?.lastPosition) {
              console.log("Last Position:", navRes.result.lastPosition);
              setLastPos(navRes.result.lastPosition);
            }
            // Restore saved font size (fallback to 100 if null / NaN / "null" / "")
            const rawFont = navRes.result?.vivekvaniFontSize;
            const parsedFont = parseFloat(rawFont);
            setLastFontSize(
              rawFont !== null && rawFont !== undefined && rawFont !== "" && rawFont !== "null" && !isNaN(parsedFont)
                ? parsedFont
                : 100
            );
            if (navRes.result?.navOrder) {
              const totalChapters = navRes.result.navigationTree.length;
              setProgress((navRes.result.navOrder / totalChapters) * 100);
            }
          }

        } catch (error) {
          console.error("fetchData Error:", error);
        } finally {
          console.log("fetchData Completed");
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [i18n.language, vivekvaniId, UserIdentity]);


  useEffect(() => {
    if (state?.vivekvaniId && UserIdentity) {
      EpubServices.getvivekvanimark(state?.vivekvaniId).then((res: any) => {
        if (res.status) {
          setVivekVaniMarkData(res?.result);
        }
      });
    }
  }, [refresh, i18n.language, userId, state?.vivekvaniId]);

  useEffect(() => {
    setRefresh(false);
    VivekVanisService.getRelatedVivekVanis(state?.vivekvaniId, UserIdentity !== "" ? UserIdentity : "", "").then((res) => {
      if (res.status) {
        setRelatedVivekVanis(res.result);
      }
    });
  }, [refresh, i18n.language, vivekvaniId, state?.vivekvaniId, UserIdentity]);

  useEffect(() => {
    VivekVanisService.GetLanguageDataById(state?.langId).then((res) => {
      showLang(res?.result?.name);
    });
  }, [i18n.language, state?.langId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="newcontainer"
      style={{ backgroundColor: "#FFF6E1", padding: "1px 0", marginTop: 0 }}
    >
      <div
        className="breadcrumbs-head newcontainer"
        style={{
          width: "100%",
          marginTop: "-175px",
          background: "none",
          backgroundColor: "#ffedbc",
          height: "240px",
          borderBottom: "2px solid #fff",
          paddingTop: 0,
        }}
      >
        <div className="breadcrumbs">
          <div
            className="containers"
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "rgb(209, 21, 1)",
              top: "155px",
              fontFamily: "ChanakyaUni",
            }}
          >
            {window.location.pathname === "/profile/fav" + state?.vivekvaniSlug &&
              t("E_vivekvanis_tr")}
            {window.location?.pathname === "/vivekvanis/" + state?.vivekvaniSlug &&
              t("E_vivekvanis_tr")}
            {window.location?.pathname === "/vivekvanis/special/" + state?.vivekvaniSlug &&
              t("Special_E_vivekvanis_tr")}
            {state?.authorId !== undefined && <span>{state?.authorName}</span>}
            {state?.langId !== undefined && <span>{lang}</span>}
            {state?.catId ? t("E_vivekvanis_tr") : ""}
            <div
              style={{
                fontSize: "19px",
                fontWeight: 600,
                color: "#2d2a29",
                marginTop: "-8px",
              }}
            >
              <Link style={{ marginRight: "8px", color: "#2d2a29" }} to="/">
                {t("Home_tr")}
              </Link>
              {window.location?.pathname === "/vivekvanis/" + state?.vivekvaniSlug ? (
                <Link
                  to={"/vivekvanis"}
                  style={{ marginRight: "6px", color: "#2d2a29" }}
                >
                  / {t("E_vivekvanis_tr")}
                </Link>
              ) : (
                ""
              )}
              {window.location?.pathname ===
                "/vivekvanis/special/" + state?.vivekvaniSlug ? (
                <Link
                  to={"/vivekvanis/special"}
                  style={{ marginRight: "6px", color: "#2d2a29" }}
                >
                  / {t("Special_E_vivekvanis_tr")}
                </Link>
              ) : (
                ""
              )}

              {state?.authorId !== undefined ? (
                <>
                  <Link
                    to={"/author/" + state?.authorSlug}
                    state={{
                      authorId: state?.authorId,
                      authorName: state?.authorName,
                      authorSlug: state?.authorSlug,
                    }}
                    style={{ marginRight: "6px", color: "#2d2a29" }}
                  >
                    {/* author name in hindi and english */}
                    /{state?.authorName}
                  </Link>
                  <Link
                    to={"/vivekvanis/author/" + state?.authorSlug}
                    state={{
                      authorId: state?.authorId,
                      authorName: state?.authorName,
                      authorSlug: state?.authorSlug,
                    }}
                    style={{ marginRight: "6px", color: "#2d2a29" }}
                  >
                    / {t("E_vivekvanis_tr")}
                  </Link>
                </>
              ) : (
                ""
              )}
              {state?.catId !== undefined && (
                <Link
                  to={"/vivekvanis/category/+"}
                  state={{
                    catId: state?.catId,
                  }}
                  style={{ marginRight: "8px", color: "#2d2a29" }}
                >
                  / {t("E_vivekvanis_tr")}
                </Link>
              )}
              {state?.langId !== undefined && (
                <>
                  <Link
                    to={"/vivekvanis/language/ +"}
                    state={{
                      langId: state?.langId,
                    }}
                    style={{ marginRight: "8px", color: "#2d2a29" }}
                  >
                    / {lang}
                  </Link>
                  <Link
                    to={"/vivekvanis/language/ +"}
                    state={{
                      langId: state?.langId,
                    }}
                    style={{ marginRight: "8px", color: "#2d2a29" }}
                  >
                    / {t("E_vivekvanis_tr")}
                  </Link>
                </>
              )}
              <span>/ {vivekvaniDetail?.name}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div style={{ marginBottom: "75px" }}>
          <div className="row">
            <div>
              {vivekvaniDetail ? (
                <div
                  className="containers card-gst"
                  style={{
                    width: "100%",
                    marginTop: "25px",
                    backgroundColor: "#FFFAF0",
                    boxShadow: "0px 0px 10px 0px #dcd1b8",
                  }}
                >
                  <div className="mat-card row" key={`vivekvani-${vivekvaniDetail.id}`} style={{ display: 'flex', alignItems: 'stretch', padding: '15px' }}>
                    <div className="single-product col-4 col-lg-4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <div
                        style={{
                          border: "1px solid #eadfc8",
                          padding: "30px",
                          background: "#fff",
                          borderRadius: "5px",
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={vivekvaniDetail.vivekVaniPath}
                          onError={(e) => {
                            e.currentTarget.src = DefaultVivekVani;
                          }}
                          onClick={() => {
                            setShowCoverPopup(true);
                          }}
                          alt={vivekvaniDetail.name}
                          title={vivekvaniDetail.name}
                          className="bkdetailimg"
                          style={{ cursor: "pointer" }}
                          width="256"
                          height="362"
                        />
                      </div>
                    </div>

                    <div className="single-product-author col-8 col-lg-8" style={{ display: 'flex', flexDirection: 'column' }}>
                      <div>
                        <div className="single-vivekvanidetail-heading">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <label
                              style={{
                                fontFamily: "ChanakyaUni,NalandaTim,Tunga",
                                fontSize: "30px",
                                fontWeight: 700,
                                color: "#472d1e",
                                margin: "12px 0 0",
                                fontStyle: "normal",
                              }}
                            >
                              {vivekvaniDetail.name}
                            </label>
                            <label
                              onClick={() => {
                                if (!UserIdentity) setLogIn(true);
                              }}
                              style={{ display: "flex", margin: 0 }}
                            >
                              <label
                                style={{
                                  display:
                                    vivekvaniMarkData?.length > 0 ? "block" : "none",
                                  marginRight: "10px",
                                }}
                              >
                                <div style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setVivekVaniMark(
                                      vivekvaniMark === true ? false : true
                                    );
                                  }}
                                >
                                  <div>
                                    <img src={vivekvanimarkIcon} style={{ width: "45px", height: "45px" }} alt="vivekvanimaarkicon" />
                                  </div>
                                  <div>
                                    {vivekvaniMark && userId && (
                                      <div className="bkmarkicon-style">
                                        <div
                                          style={{
                                            display: "flex",
                                            backgroundColor: "#ff6427",
                                          }}
                                        >
                                          <p
                                            style={{
                                              color: "#fff",
                                              fontStyle: "normal",
                                              lineHeight: "normal",
                                              borderBottom: "none",
                                              padding: "0 0 0 10%",
                                              margin: 0,
                                            }}
                                          >
                                            {t("bk_mark_tr")}
                                          </p>
                                          <img
                                            src={closeicon}
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              margin: "4px 0 0 10px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => setVivekVaniMark(false)}
                                            alt=""
                                          />
                                        </div>
                                        <ol style={{ paddingLeft: "20px", fontSize: "20px" }}>
                                          {vivekvaniMarkData &&
                                            vivekvaniMarkData?.map(
                                              (item: any, index: number) => (
                                                <li
                                                  key={index}
                                                  onClick={() => {
                                                    navigate(
                                                      `/reader/vivekvanis/` +
                                                      vivekvaniDetail?.slug,
                                                      {
                                                        state: {
                                                          vivekvaniDetailId:
                                                            vivekvaniDetail?.id,
                                                          vivekvaniName:
                                                            vivekvaniDetail?.name,
                                                          slug: vivekvaniDetail?.slug,
                                                          location: item?.cfi,
                                                          chapterName: item?.name,
                                                          type: BookContentType.vivek,
                                                          fontsize: lastFontSize,
                                                        },
                                                      }
                                                    );
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      borderBottom: "none",
                                                      padding: 0,
                                                      margin: "0 0 0 5px",
                                                      color: "#000",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    {item?.name}
                                                  </p>
                                                </li>
                                              )
                                            )}
                                        </ol>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </label>
                              <label
                                onClick={() => {
                                  toggleLike();
                                  notify();
                                }}
                              >
                                <img
                                  src={isLiked ? Favfill : Favempty}
                                  alt="img"
                                  style={{ width: "45px", cursor: "pointer" }}
                                />
                              </label>
                            </label>
                          </div>
                        </div>

                        {vivekvaniDetail.author ? (
                          <div>
                            <p>
                              <label>{t("Authors_tr")}</label>
                              {vivekvaniDetail.author}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        {vivekvaniDetail.vivekvaniLanguage ? (
                          <div>
                            <p>
                              <label>{t("Language_tr")} </label>
                              {vivekvaniDetail.vivekvaniLanguage}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div style={{ marginTop: "20px" }}>
                        <div
                          className="notification-bar"
                          ref={notificationRef}
                          style={{
                            color: "#ff3d28",
                            fontSize: "20px",
                            marginBottom: "10px",
                          }}
                        ></div>

                        <div className="actions">
                          {progress > 0 && (
                            <div className="vivekvani-progress">
                              <div className="vivekvani-progress__label">{Math.round(progress)} %</div>
                              <div className="vivekvani-progress__track">
                                <div className="vivekvani-progress__value" style={{ width: `${progress}%` }}></div>
                              </div>
                            </div>
                          )}
                          <div className="buttons">
                            {progress === 0 ? (
                              <button
                                className="btn-vivekvani-action"
                                onClick={() => {
                                  if (UserIdentity) {
                                    navigate(`/reader/vivekvanis/` + vivekvaniDetail?.slug, {
                                      state: {
                                        vivekvaniDetailId: vivekvaniDetail?.id,
                                        vivekvaniName: vivekvaniDetail?.name,
                                        slug: vivekvaniDetail?.slug,
                                        label: vivekvaniDetail?.label,
                                        type: BookContentType.vivek,
                                      },
                                    });
                                  } else {
                                    setLogIn(true);
                                  }
                                }}
                              >
                                {t("Read_the_book_tr")}
                              </button>
                            ) : (
                              <>
                                <button
                                  className="btn-vivekvani-action"
                                  onClick={() => {
                                    if (UserIdentity) {
                                      navigate(`/reader/vivekvanis/` + vivekvaniDetail?.slug, {
                                        state: {
                                          vivekvaniDetailId: vivekvaniDetail?.id,
                                          vivekvaniName: vivekvaniDetail?.name,
                                          slug: vivekvaniDetail?.slug,
                                          label: vivekvaniDetail?.label,
                                          type: BookContentType.vivek,
                                        },
                                      });
                                    } else {
                                      setLogIn(true);
                                    }
                                  }}
                                >
                                  {t("Read_From_Start_tr")}
                                </button>
                                <button
                                  className="btn-vivekvani-action"
                                  onClick={() => {
                                    navigate(`/reader/vivekvanis/` + vivekvaniDetail?.slug, {
                                      state: {
                                        vivekvaniDetailId: vivekvaniDetail?.id,
                                        vivekvaniName: vivekvaniDetail?.name,
                                        slug: vivekvaniDetail?.slug,
                                        location: lastPos,
                                        type: BookContentType.vivek,
                                        fontsize: lastFontSize,
                                      },
                                    });
                                  }}
                                >
                                  {t("Continue_Reading_tr")}
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ margin: "0 45px 5% 40px" }}>
                    <div className="tabs-container">
                      <div className="tabs-line">
                        <div className="tabs" role="tablist">
                          {hasVisibleDescription && (
                            <button
                              className="tab"
                              aria-selected={activeTab === 'description'}
                              onClick={() => setActiveTab('description')}
                            >
                              {t("Description_tr")}
                            </button>
                          )}
                          {hasToc && (
                            <button
                              className="tab"
                              aria-selected={activeTab === 'toc'}
                              onClick={() => setActiveTab('toc')}
                            >
                              {t("Table_of_Contents_tr")}
                            </button>
                          )}
                        </div>
                        <div
                          className="tab-indicator"
                          style={{
                            transform: `translateX(${indicatorTranslate})`,
                            width: '140px'
                          }}
                        ></div>
                      </div>

                      <div className="tab-panels">
                        {hasVisibleDescription && (
                          <div className={`panel ${activeTab === 'description' ? 'active' : ''}`}>
                            <div dangerouslySetInnerHTML={createMarkup()}></div>
                          </div>
                        )}

                        {hasToc && (
                          <div className={`panel ${activeTab === 'toc' ? 'active' : ''}`}>
                            <ul className="toc">
                              {navigationTree.map((node: any, idx: number) => renderTocNode(node, idx))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="clsslide">
                    {relateds && relateds?.length > 5 ? (
                      <div>
                        <h1
                          style={{ fontSize: "30px!important" }}
                          className="heading-related"
                        >
                          {t("Related_e_vivekvanis_tr")}
                        </h1>

                        <div
                          style={{
                            paddingBottom: "20px",
                            width: " 97%",
                            left: "18px",
                            position: "relative",
                          }}
                        >
                          <Slider {...settings}>
                            {relateds && relateds?.length > 0
                              ? relateds.map((related) => (
                                <div
                                  style={{ display: "flex" }}
                                  className="slider-vivekvanis sidebarmargin"
                                  key={`related-${related.id}`}
                                  onClick={() => {
                                    if (
                                      window.location.pathname ===
                                      `/vivekvanis/` + state?.vivekvaniSlug
                                    ) {
                                      navigate(`/vivekvanis/` + related?.slug, {
                                        state: {
                                          vivekvaniId: related?.id,
                                          vivekvaniName: related?.name,
                                          vivekvaniSlug: related?.slug,
                                          special: window?.location?.pathname,
                                          pathname:
                                            window?.location?.pathname,
                                        },
                                      });
                                    }
                                    if (
                                      window.location.pathname ===
                                      `/vivekvanis/special/` + state?.vivekvaniSlug
                                    ) {
                                      navigate(
                                        `/vivekvanis/special/` + related?.slug,
                                        {
                                          state: {
                                            vivekvaniId: related?.id,
                                            vivekvaniName: related?.name,
                                            vivekvaniSlug: related?.slug,
                                            special: window?.location?.pathname,
                                            pathname:
                                              window?.location?.pathname,
                                          },
                                        }
                                      );
                                    }
                                    if (
                                      window.location.pathname ===
                                      "/vivekvanis/author/" +
                                      state?.authorSlug +
                                      "/" +
                                      state?.vivekvaniSlug
                                    ) {
                                      navigate(
                                        "/vivekvanis/author/" +
                                        state?.authorSlug +
                                        "/" +
                                        related?.slug,
                                        {
                                          state: {
                                            vivekvaniId: related?.id,
                                            vivekvaniName: related?.name,
                                            vivekvaniSlug: related?.slug,
                                            authorId: state?.authorId,
                                            authorName: state?.authorName,
                                            authorSlug: state?.authorSlug,
                                            pathname:
                                              window?.location?.pathname,
                                          },
                                        }
                                      );
                                    }
                                    if (
                                      window?.location?.pathname ===
                                      `/vivekvanis/category/` +
                                      state?.catSlug +
                                      "/" +
                                      state?.vivekvaniSlug
                                    ) {
                                      navigate(
                                        `/vivekvanis/category/` +
                                        state?.catSlug +
                                        "/" +
                                        related?.slug,
                                        {
                                          state: {
                                            vivekvaniId: related?.id,
                                            vivekvaniName: related?.name,
                                            catId: state?.catId,
                                            catSlug: state?.catSlug,
                                            vivekvaniSlug: related?.slug,
                                            pathname:
                                              window?.location?.pathname,
                                          },
                                        }
                                      );
                                    }
                                    if (
                                      window?.location?.pathname ===
                                      `/vivekvanis/language/` +
                                      state?.langId +
                                      "/" +
                                      state?.vivekvaniSlug
                                    ) {
                                      navigate(
                                        `/vivekvanis/language/` +
                                        state?.langId +
                                        "/" +
                                        related.slug,
                                        {
                                          state: {
                                            vivekvaniId: related?.id,
                                            vivekvaniName: related?.name,
                                            vivekvaniSlug: related?.slug,
                                            langId: state?.langId,
                                            pathname:
                                              window?.location?.pathname,
                                          },
                                        }
                                      );
                                    }
                                    window.location.reload();
                                  }}
                                >
                                  <div>
                                    <img
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      className="imgcenter"
                                      src={
                                        related?.vivekvaniThumbPath == null
                                          ? DefaultVivekVani
                                          : related?.vivekvaniThumbPath
                                      }
                                      onError={(e) => {
                                        e.currentTarget.src = DefaultVivekVani;
                                      }}
                                      alt={related?.name}
                                      title={related?.name}
                                      width="150"
                                      height="212"
                                    />
                                    <p>{related?.name?.length > 35
                                      ? related?.name?.slice(0, 35) + "..."
                                      : related?.name}</p>
                                  </div>
                                </div>
                              ))
                              : ""}
                          </Slider>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : loading ? (
                <div className="evivekvanis-category resultnotfound">
                  <Loader loading={loading} />
                </div>
              ) : (
                <div className="evivekvanis-category resultnotfound">
                  {t("result_not_found_tr")}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <LogInModel
        opens={logIn}
        onCloses={closeModal}
        onLoginStateChange={handleLoginStateChange}
      />
      {vivekvaniDetail && (
        <VivekVaniCoverPopup
          show={showCoverPopup}
          onClose={() => setShowCoverPopup(false)}
          imagePath={vivekvaniDetail.vivekVaniPath}
          bookName={vivekvaniDetail.name}
        />
      )}
    </div >
  );
};
export default VivekVaniDetailPage;
